import React from 'react';
import PropTypes from 'prop-types';

import { Box } from 'Components/Base';

import ArticleFragment from './Components/ArticleFragment/ArticleFragment';
import AssignmentSubmission from './Containers/AssignmentSubmission/AssignmentSubmission';

const Assignments = ({ contentTitle, content, courseAssetId, classroomId, onCompleted }) => {
  return (
    <>
      <Box p={{ lg: 6 }}>
        <Box mb={6}>
          <ArticleFragment title={contentTitle} content={content?.detail?.content} />
        </Box>
        <AssignmentSubmission
          content={content}
          classroomId={classroomId}
          courseAssetId={courseAssetId}
          onCompleted={onCompleted}
        />
      </Box>
    </>
  );
};

Assignments.propTypes = {
  contentTitle: PropTypes.string,
  content: PropTypes.object,
  courseAssetId: PropTypes.string,
  classroomId: PropTypes.string,
};

export default Assignments;
